import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../../../../../CommonUtils/authFetch';

export interface Client {
  FirstName: string;
  LastName: string;
  Email: string | null;
  Id: number;
}

export const fetchClientList = async (): Promise<Client[]> => {
  const { Clients } = await authFetch('/Adviser/Adviser/GetClients');

  return Clients;
};

export const useClientListQuery = () => {
  return useQuery(
    ['Profile', 'Accounts', 'MoveAccount', 'ClientList'],

    () => fetchClientList(),

    { cacheTime: 0 },
  );
};
